import React from 'react';

import { type FTimelineLogItemFragment, TimelineLogMessageKey } from '@dashboard/generated/wp/platform';
import {
  DraftsOutlined,
  ErrorOutline,
  MarkEmailReadOutlined,
  MemoryOutlined,
  OutboxOutlined,
  PauseCircleOutline,
  SendOutlined,
  TouchAppOutlined,
  UnsubscribeOutlined,
} from '@mui/icons-material';

export function getTimelineLogItemIcon(event: FTimelineLogItemFragment): JSX.Element {
  switch (event.messageKey) {
    case TimelineLogMessageKey.EmailMessageCreated:
      return <MarkEmailReadOutlined fontSize="small" sx={{ color: 'grey.600' }} />;
    case TimelineLogMessageKey.EmailMessagePaused:
      return <PauseCircleOutline fontSize="small" sx={{ color: 'grey.600' }} />;
    case TimelineLogMessageKey.EmailMessageRendered:
      return <MemoryOutlined fontSize="small" sx={{ color: 'grey.600' }} />;
    case TimelineLogMessageKey.EmailMessageDeliveredSesEvent:
      return <SendOutlined fontSize="small" sx={{ color: 'grey.600' }} />;
    case TimelineLogMessageKey.EmailMessageOpenSesEvent:
      return <DraftsOutlined fontSize="small" sx={{ color: 'grey.600' }} />;
    case TimelineLogMessageKey.EmailMessageClickedSesEvent:
      return <TouchAppOutlined fontSize="small" sx={{ color: 'grey.600' }} />;
    case TimelineLogMessageKey.EmailMessageSentSesEvent:
    case TimelineLogMessageKey.EmailMessageSentSandboxEvent:
      return <OutboxOutlined fontSize="small" sx={{ color: 'grey.600' }} />;
    case TimelineLogMessageKey.EmailMessageRemovedOptOutRecipientEvent:
    case TimelineLogMessageKey.EmailMessageContactUnsubscribed:
    case TimelineLogMessageKey.EmailMessageHalted:
      return <UnsubscribeOutlined fontSize="small" sx={{ color: 'grey.600' }} />;
    case TimelineLogMessageKey.EmailMessageBounceSesEvent:
    case TimelineLogMessageKey.EmailMessageBounceSuppressed:
    case TimelineLogMessageKey.EmailMessageComplaintSesEvent:
    case TimelineLogMessageKey.EmailMessageComplaintSuppressed:
    case TimelineLogMessageKey.EmailMessageSendingDisabledError:
    case TimelineLogMessageKey.EmailMessageInvalidSenderError:
    case TimelineLogMessageKey.EmailMessageInvalidParameterError:
    case TimelineLogMessageKey.EmailMessageEmptyRecipientsError:
    case TimelineLogMessageKey.EmailMessageInvalidRecipientsError:
    case TimelineLogMessageKey.UnknownEmailMessageRenderError:
    case TimelineLogMessageKey.UnknownEmailMessageSendError:
    case TimelineLogMessageKey.EmailMessageSenderNotApprovedError:
    case TimelineLogMessageKey.EmailMessageInvalidTestModeRecipientError:
    case TimelineLogMessageKey.EmailMessageRenderError:
    case TimelineLogMessageKey.EmailMessageInvalidEmailAddressError:
    case TimelineLogMessageKey.EmailMessageInvalidFileError:
    case TimelineLogMessageKey.EmailMessageInvalidDomainNameError:
      return <ErrorOutline fontSize="small" sx={{ color: 'grey.600' }} />;
  }
}

export function getTimelineLogItemLabel(event: FTimelineLogItemFragment): string {
  switch (event.messageKey) {
    case TimelineLogMessageKey.EmailMessageCreated:
      return 'Created';
    case TimelineLogMessageKey.EmailMessagePaused:
      return 'Paused';
    case TimelineLogMessageKey.EmailMessageRendered:
      return 'Processed';
    case TimelineLogMessageKey.EmailMessageDeliveredSesEvent:
      return 'Delivered';
    case TimelineLogMessageKey.EmailMessageOpenSesEvent:
      return 'Opened';
    case TimelineLogMessageKey.EmailMessageClickedSesEvent:
      return 'Clicked';
    case TimelineLogMessageKey.EmailMessageRemovedOptOutRecipientEvent:
    case TimelineLogMessageKey.EmailMessageHalted:
    case TimelineLogMessageKey.EmailMessageBounceSuppressed:
    case TimelineLogMessageKey.EmailMessageComplaintSuppressed:
      return 'Suppressed';
    case TimelineLogMessageKey.EmailMessageContactUnsubscribed:
      return 'Unsubscribed';
    case TimelineLogMessageKey.EmailMessageBounceSesEvent:
      return 'Bounce';
    case TimelineLogMessageKey.EmailMessageComplaintSesEvent:
      return 'Complaint';
    case TimelineLogMessageKey.EmailMessageSentSesEvent:
    case TimelineLogMessageKey.EmailMessageSentSandboxEvent:
      return 'Sent';
    case TimelineLogMessageKey.EmailMessageSendingDisabledError:
    case TimelineLogMessageKey.EmailMessageInvalidSenderError:
    case TimelineLogMessageKey.EmailMessageInvalidParameterError:
    case TimelineLogMessageKey.EmailMessageEmptyRecipientsError:
    case TimelineLogMessageKey.EmailMessageInvalidRecipientsError:
    case TimelineLogMessageKey.UnknownEmailMessageRenderError:
    case TimelineLogMessageKey.UnknownEmailMessageSendError:
    case TimelineLogMessageKey.EmailMessageSenderNotApprovedError:
    case TimelineLogMessageKey.EmailMessageInvalidTestModeRecipientError:
    case TimelineLogMessageKey.EmailMessageRenderError:
    case TimelineLogMessageKey.EmailMessageInvalidEmailAddressError:
    case TimelineLogMessageKey.EmailMessageInvalidFileError:
    case TimelineLogMessageKey.EmailMessageInvalidDomainNameError:
      return 'Error';
  }
}
